import React, { useContext, useEffect } from "react";
import { CartContext } from "../../context/CartContext";
import ml from "../../assets/img/ml.jpg";

const CartLeft = () => {
    const { cart, updateQuantity, removeFromCart } = useContext(CartContext);

  useEffect(() => {
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100); // Adjust delay if necessary
}, []);
console.log(cart);
    return (
        <div className="cart-left">
            <div className="table-responsive">
                <table className="table table-cart align-middle">
                    <thead>
                        <tr>
                            <th>Image</th>
                            <th style={{ width: '200px' }}>Name</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th style={{ width: '150px' }}>Total</th>
                            <th className="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cart.map((item) => (
                            <tr key={item.id}>
                                <td>
                                    <div className="cart-thumb">
                                        <img src={item.image} className="img-fluid" alt={item.name} />
                                    </div>
                                </td>
                                <th style={{ width: '200px' }}>{item.name}</th>
                                <td>£{item.price}</td>
                                <td>
                                    <input
                                        type="number"
                                        min="1"
                                        value={item.quantity}
                                        onChange={(e) => updateQuantity(item.id, e.target.value)}
                                    />
                                </td>
                                <td style={{ width: '150px' }}>£{(item.price * item.quantity).toFixed(2)}</td>
                                <td className="text-center">
                                    <button
                                        onClick={() => removeFromCart(item.id)}
                                        className="btn btn-sm btn-danger"
                                    >
                                        <i className="bi bi-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CartLeft;
